import { Button, Section } from '@react-email/components'
import { type ReactNode } from 'react'

export function ButtonLink({
  href,
  children,
}: {
  href: string
  children: ReactNode
}) {
  const buttonClass =
    'mx-auto inline-block rounded-full px-[16px] py-[12px] text-center text-white font-semibold'

  const buttonStyle = {
    backgroundColor: 'hsla(192, 85%, 31%, 1)',
    fontSize: '16px',
  }

  return (
    <Section className="my-[32px] text-center">
      <Button className={buttonClass} style={buttonStyle} href={href}>
        {children}
      </Button>
    </Section>
  )
}
